import ThankPage from './ThankPage.jsx';

export {
  ThankPage
}


// WEBPACK FOOTER //
// ./pages/thank/index.js